import { Component } from '@angular/core';
import { SecoesHomepageComponent } from './secoes-homepage/secoes-homepage.component';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css'],
  imports: [SecoesHomepageComponent],
})
export class HomepageComponent {}
